import axiosInstance, { API_ROUTES } from '../lib/http/httpRequest';
import { AxiosResponse } from 'axios';
import { LoginResponse } from '@/state/auth/authTypes';
import { AUTH_SOCIALS, SignupPayload, SignupResponse } from '@/lib/types/generalTypes';

export const loginUserApi = (
    username: string,
    password: string,
    captchaToken: string,
): Promise<AxiosResponse<LoginResponse>> =>
    axiosInstance.post<LoginResponse>(API_ROUTES.LOGIN, {
        username,
        password,
        captchaToken,
        otp: 'TEMP_OTP_PLACEHOLDER',
    });

export const newUserRegistrationApi = (
    payload: SignupPayload,
): Promise<AxiosResponse<SignupResponse>> => axiosInstance.post(API_ROUTES.REGISTRATION, payload);

export const logoutUserApi = (): Promise<AxiosResponse<void>> =>
    axiosInstance.get(API_ROUTES.LOGOUT);

export const confirmSsoToken = (
    ssoToken: string,
    memberId: number,
): Promise<AxiosResponse<LoginResponse>> =>
    axiosInstance.post(API_ROUTES.SSO_CONFIRM, { ssoToken, memberId });

export const verifyEmailToken = (token): Promise<AxiosResponse<void>> =>
    axiosInstance.get(`${API_ROUTES.VERIFY_EMAIL}/${token}`);

export const resetPassword = (payload: {
    username?: string;
    email?: string;
    captchaToken: string;
}): Promise<AxiosResponse<void>> => axiosInstance.post(API_ROUTES.RESET_PASSWORD, payload);

export const confirmResetPassword = (payload: {
    token: string;
    password: string;
}): Promise<AxiosResponse<void>> => axiosInstance.post(API_ROUTES.CONFIRM_RESET_PASSWORD, payload);

export const resendVerificationEmail = ({
    id,
    captchaToken,
}: {
    id: number;
    captchaToken: string;
}): Promise<AxiosResponse<void>> =>
    axiosInstance.get(`${API_ROUTES.RESEND_EMAIL}/${id}/${captchaToken}`);

export const trackingClicks = (target: string): Promise<AxiosResponse<void>> =>
    axiosInstance.post(`${API_ROUTES.TRACKING_CLICKS}`, { target });

export const socialLogin = (data: {
    token: string;
    social: AUTH_SOCIALS;
}): Promise<AxiosResponse<LoginResponse>> =>
    axiosInstance.post<LoginResponse>(API_ROUTES.SOCIAL_LOGIN, data);
export const socialRegister = (data: {
    token: string;
    social: AUTH_SOCIALS;
    username: string;
    allowMarketingEmails: boolean;
}): Promise<AxiosResponse<LoginResponse>> =>
    axiosInstance.post<LoginResponse>(API_ROUTES.SOCIAL_REGISTER, data);

export const checkUser = (username: string): Promise<AxiosResponse<any>> =>
    axiosInstance.post(API_ROUTES.CHECK_USER, { username });
